const feedback = {
  submittime: "提交时间",
  processStatus: "解决状态",
  feedbackStatusYes: "打开",
  feedbackStatusNo: "关闭",
  suggestionDetail: "反馈详情",
  mobile: "手机号码",
  replayStatus: "回复状态",
  feedbackRepliedYes: "已回复",
  feedbackRepliedNo: "未回复",
  process: "处理",
  reply: "回复",
  image1: "图片1",
  image2: "图片2",
  image3: "图片3",
  detail: "回复内容",
  title: "反馈问题",
  questions: "问题",
  search: {
    width1: "70px",
    width2: "70px",
    width3: "70px"
  },
  message1: "请输入内容"
} 
export default feedback